var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccueil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7FBC4D",
    fillRule: "nonzero",
    d: "M7.5 18.5h-4V11a.5.5 0 0 0-.5-.5H1.303L10 2.673l8.697 7.827H17a.5.5 0 0 0-.5.5v7.5h-4V13a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M9.5 12.5h3V18a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-7.5H21a.5.5 0 0 0 .334-.872l-10-9a.5.5 0 0 0-.668 0l-10 9A.5.5 0 0 0 1 10.5h2.5V18a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5.5zm-1 5h-4V10a.5.5 0 0 0-.5-.5H2.303L11 1.673 19.697 9.5H18a.5.5 0 0 0-.5.5v7.5h-4V12a.5.5 0 0 0-.5-.5H9a.5.5 0 0 0-.5.5v5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1-2h24v24H-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccueil);
export default __webpack_public_path__ + "static/media/ic-accueil.cc5b68b4781289b82e052abcafc513b3.svg";
export { ForwardRef as ReactComponent };